import React from "react";
import ReviewStep from "./ReviewStep";
import { useOnboarding } from "context/OnboardingContext";

const UserReview = () => {
  const { claimMeta } = useOnboarding();
  const claimLabel = claimMeta?.claim_type === "build_device"
    ? "Build + Device"
    : claimMeta?.claim_type === "device"
    ? "Device"
    : "Build";

  return (
    <ReviewStep
      stepKey="users"
      title={`${claimLabel} Users`}
      fields={[{ name: "email", label: "User Email" }]}
    />
  );
};

export default UserReview;
